var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "select-ded-box" },
    [
      _c(
        "el-dialog",
        { attrs: { title: "抵扣选择", visible: true } },
        [
          _c(
            "div",
            {
              staticStyle: {
                height: "30px",
                width: "100%",
                "text-align": "left",
                "line-height": "30px",
                "padding-left": "10px",
                "background-color": "#f3f3f3"
              }
            },
            [
              _vm._v(
                "\n      统计： 共" +
                  _vm._s(_vm.dedTotal.num) +
                  "件，计" +
                  _vm._s(_vm.dedTotal.amount) +
                  "元\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "el-table",
            { attrs: { data: _vm.list } },
            [
              _c("el-table-column", {
                attrs: { prop: "goods_img", label: "商品图片" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "div",
                          { staticStyle: { width: "50px", height: "50px" } },
                          [
                            _c("img", {
                              directives: [
                                { name: "viewer", rawName: "v-viewer" }
                              ],
                              staticStyle: { width: "100%", height: "100%" },
                              attrs: { src: scope.row.goods_img[0] }
                            })
                          ]
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "cg_type", label: "交易方式", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "referer_type", label: "来源" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "goods_name", label: "商品名称" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "goods_no", label: "商品货号" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "goods_kh", label: "商品款号" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "price", label: "代采单价" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "num", label: "待抵扣" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              Number(scope.row.num) - Number(scope.row.used_num)
                            ) +
                            "\n          /\n          " +
                            _vm._s(
                              parseFloat(
                                Number(scope.row.num - scope.row.used_num) *
                                  Number(scope.row.price)
                              ).toFixed(2)
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "goods_name", label: "选择使用", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("el-input-number", {
                          attrs: {
                            size: "mini",
                            min: 0,
                            max: Number(scope.row.num),
                            step: 1,
                            "step-strictly": true
                          },
                          model: {
                            value: scope.row.used_num,
                            callback: function($$v) {
                              _vm.$set(scope.row, "used_num", $$v)
                            },
                            expression: "scope.row.used_num"
                          }
                        })
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                height: "40px",
                width: "100%",
                "margin-top": "24px",
                position: "relative"
              }
            },
            [
              _c("div", { staticStyle: { position: "absolute", right: "0" } }, [
                _c("div", [_c("p"), _vm._v(" "), _c("p")]),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("span", [
                      _vm._v(
                        "账单金额：共" +
                          _vm._s(_vm.anArr.num) +
                          "件，计" +
                          _vm._s(_vm.anArr.amount) +
                          "\n                " +
                          _vm._s(_vm.getDedTotal)
                      )
                    ]),
                    _vm._v("\n            \n          "),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.closeDialog(1, { close: true })
                          }
                        }
                      },
                      [_vm._v("取 消")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: { click: _vm.submitDed }
                      },
                      [_vm._v("确 定")]
                    )
                  ],
                  1
                )
              ])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5efd4a13", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5efd4a13","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/supplybill/components/SelectDedGoods.vue
// module id = null
// module chunks = 